import * as types from "../types/performance.types";
import { 
  getPerformanceList
} from '../../services/performance.service';
import { validationErrors } from "../../utils/Helpers";

// Performance Page Action
export const listPerformanceAction = (data) => {
  return async (dispatch, getState) => {
    dispatch({
      type: types.SET_PERFORMANCE_LOADER,
      payload: true,
    });
    try {
      await getPerformanceList(getState().authReducer.token, getState().authReducer.user.id, data)
      .then((res) => {
        dispatch({
          type: types.SET_PERFORMANCE_LIST_DATA,
          payload: res.data.data,
        });
        dispatch({
          type: types.SET_PERFORMANCE_LIST_PAGINATION,
          payload: res.data.pagination,
        });
      })
    } catch (e) {validationErrors(e)} finally {
      dispatch({
        type: types.SET_PERFORMANCE_LOADER,
        payload: false,
      });
    }
  };
};

export const filterPerformanceAction = (data) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_PERFORMANCE_LIST_FILTER,
      payload: data,
    });
  };
};